import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { Box, CircularProgress, Container } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import { useValidateResetPasswordToken } from 'features/reset-password/services/reset-password.service';
import ResetPasswordForm from 'features/reset-password/components/reset-password-form/reset-password-form.component';

import { useStyles } from './reset-password-token-validation.styles';

export const ResetPasswordTokenValidationPage = () => {
  const [tokenStatus, setTokenStatus] = useState('loading');
  const [token, setToken] = useState('');

  const { search } = useLocation();
  const { mutate } = useValidateResetPasswordToken();
  const classes = useStyles();

  useEffect(() => {
    const queryString = new URLSearchParams(search);
    const resetToken = queryString.get('token');

    setToken(resetToken || '');

    if (resetToken) {
      mutate(
        { resetToken },
        {
          onSuccess: () => setTokenStatus('valid'),
          onError: ({ response }) => {
            if (response?.status === 401 || response?.status === 404) {
              setTokenStatus('invalid');
            }
          },
        },
      );
    }
  }, [search, mutate]);

  return (
    <Container className={classes.container}>
      <Box className={classes.wrapper}>
        {tokenStatus === 'loading' && <CircularProgress />}
        {tokenStatus === 'invalid' && (
          <Alert severity="error">
            Por seguridad, el enlace para restablecer tu contraseña ya no es
            válido o ya fue utilizado.
          </Alert>
        )}
        {tokenStatus === 'valid' && <ResetPasswordForm resetToken={token} />}
      </Box>
    </Container>
  );
};
